import FormLabels from "../en/form-labels.js";
export default FormLabels;